import { useState } from "react";
import { motion } from "framer-motion";

const SpeedLines = () => (
  <div
    className="absolute inset-y-0 left-full ml-3 flex flex-col justify-center gap-3.5 pointer-events-none"
    aria-hidden="true"
  >
    {[0, 1, 2].map((i) => (
      <motion.span
        key={i}
        className="block h-[5px] rounded-full bg-[#111111]/55"
        style={{ width: 48 - i * 10 }}
        animate={{ x: [-8, 26], opacity: [0, 0.85, 0] }}
        transition={{
          duration: 0.8,
          repeat: Infinity,
          ease: "easeOut",
          delay: i * 0.13,
        }}
      />
    ))}
  </div>
);

const Exhaust = () => (
  <div
    className="absolute block pointer-events-none"
    style={{ left: "96%", top: "82%" }}
    aria-hidden="true"
  >
    {[0, 1, 2].map((i) => (
      <motion.span
        key={i}
        className="absolute block rounded-full bg-[#111111]/25"
        style={{ width: 13 - i * 2, height: 13 - i * 2 }}
        animate={{
          x: [0, 20 + i * 8],
          y: [0, -8 - i * 6],
          opacity: [0, 0.5, 0],
          scale: [0.5, 1.4],
        }}
        transition={{
          duration: 1.2,
          repeat: Infinity,
          ease: "easeOut",
          delay: i * 0.35,
        }}
      />
    ))}
  </div>
);

// One-time puff of pink smoke when the truck arrives
const ArrivalPuff = () => (
  <div
    className="absolute left-1/2 -translate-x-1/2 pointer-events-none"
    style={{ bottom: "-4%" }}
    aria-hidden="true"
  >
    {[-2, -1, 0, 1, 2].map((dir, i) => (
      <motion.span
        key={dir}
        className="absolute block rounded-full bg-[#ff648b]"
        style={{ width: 20, height: 20, left: -10, bottom: 0 }}
        initial={{ opacity: 0, scale: 0.3, x: 0, y: 0 }}
        animate={{
          opacity: [0, 0.8, 0],
          scale: [0.3, 1.7],
          x: dir * 28,
          y: -12 - Math.abs(dir) * 5,
        }}
        transition={{ duration: 0.95, ease: "easeOut", delay: 0.03 * i }}
      />
    ))}
  </div>
);

export const MovingTruck = () => {
  const [arrived, setArrived] = useState(false);

  return (
    <motion.div
      className="relative mx-auto mb-2 w-56 sm:w-72"
      data-testid="contact-truck"
      initial={{ x: 60, opacity: 0 }}
      whileInView={{ x: 0, opacity: 1 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ type: "spring", stiffness: 90, damping: 9, mass: 0.8 }}
      onAnimationComplete={() => setArrived(true)}
    >
      <SpeedLines />
      <Exhaust />
      {arrived && <ArrivalPuff />}
      <motion.div
        className="relative"
        animate={{ y: [0, -4, 0, -2, 0], rotate: [-0.7, 0.7, -0.7] }}
        transition={{ duration: 1.1, repeat: Infinity, ease: "easeInOut" }}
        whileHover={{ scale: 1.05 }}
        style={{ transformOrigin: "bottom center" }}
      >
        <img
          src="/logo-truck.png?v=3"
          alt="Bobo's Donuts truck with a pink donut on top"
          data-testid="contact-truck-img"
          className="h-auto w-full select-none drop-shadow-xl sm:drop-shadow-2xl"
        />
      </motion.div>
    </motion.div>
  );
};
